import React, { useState } from "react";
import { useTranslation } from 'react-i18next'; // Import the hook

export default function Footer() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [offerOpen, setOfferOpen] = useState(false);

  const { t } = useTranslation(); // Hook to access translation function

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleOffer = () => setOfferOpen(!offerOpen);

  return (
    <div className="bg-white text-gray-600 py-10">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-6">
        {/* Left Section */}
        <div>
          <img
            src="assets/logo.png"
            alt="Company Logo"
            className="w-12 mb-4"
          />
          <div className="mb-4">
            <p className="font-semibold">{t('footer.email')}</p>
            <a
              href="mailto:hr@omrancorp.com"
              className="text-blue-500 hover:underline"
            >
              hr@omrancorp.com
            </a>
          </div>
          <div>
            <p className="font-semibold">{t('footer.office')}</p>
            <p>{t('footer.address')}</p>
          </div>
        </div>

        {/* Center Section */}
        <div className="hidden md:flex flex-col items-center mt-16">
          <ul className="space-y-4 text-center">
            <li><a href="/" className="hover:underline">{t('footer.home')}</a></li>
            <li><a href="/about" className="hover:underline">{t('footer.about')}</a></li>
            <li><a href="/contact" className="hover:underline">{t('footer.contact')}</a></li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="hidden md:grid grid-cols-2 gap-4 mt-16">
          <ul className="space-y-4">
            <li><a href="/realestate" className="hover:underline">{t('footer.sectorsRealEstate')}</a></li>
            <li><a href="/financial" className="hover:underline">{t('footer.sectorsFinancial')}</a></li>
            <li><a href="/transportation" className="hover:underline">{t('footer.sectorsTransportation')}</a></li>
            <li><a href="/manufacturing" className="hover:underline">{t('footer.sectorsManufacturing')}</a></li>
          </ul>
          <ul className="space-y-4">
            <li><a href="/education" className="hover:underline">{t('footer.sectorsEducation')}</a></li>
            <li><a href="/energyandmaterial" className="hover:underline">{t('footer.sectorsEnergyAndMaterial')}</a></li>
            <li><a href="/food" className="hover:underline">{t('footer.sectorsFood')}</a></li>
          </ul>
        </div>

        {/* Mobile Dropdown Menu */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="flex items-center justify-between w-full py-2 text-left"
          >
            <span className="font-semibold">{t('footer.menu')}</span>
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`ml-2 transform ${menuOpen ? "rotate-180" : "rotate-0"}`}
            >
              <path
                d="M1 1.09131L7 7.09131L13 1.09131"
                stroke="#272727"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {menuOpen && (
            <ul className="space-y-2 mt-2">
              <li><a href="/" className="hover:underline">{t('footer.home')}</a></li>
              <li><a href="/about" className="hover:underline">{t('footer.about')}</a></li>
              <li><a href="/contact" className="hover:underline">{t('footer.contact')}</a></li>
            </ul>
          )}

          <button
            onClick={toggleOffer}
            className="flex items-center justify-between w-full py-2 text-left mt-4"
          >
            <span className="font-semibold">{t('footer.offer')}</span>
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`ml-2 transform ${offerOpen ? "rotate-180" : "rotate-0"}`}
            >
              <path
                d="M1 1.09131L7 7.09131L13 1.09131"
                stroke="#272727"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {offerOpen && (
            <ul className="space-y-2 mt-2">
              <li><a href="/realestate" className="hover:underline">{t('footer.sectorsRealEstate')}</a></li>
              <li><a href="/financial" className="hover:underline">{t('footer.sectorsFinancial')}</a></li>
              <li><a href="/transportation" className="hover:underline">{t('footer.sectorsTransportation')}</a></li>
              <li><a href="/manufacturing" className="hover:underline">{t('footer.sectorsManufacturing')}</a></li>
              <li><a href="/education" className="hover:underline">{t('footer.sectorsEducation')}</a></li>
              <li><a href="/energyandmaterial" className="hover:underline">{t('footer.sectorsEnergyAndMaterial')}</a></li>
              <li><a href="/food" className="hover:underline">{t('footer.sectorsFood')}</a></li>
            </ul>
          )}
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="max-w-7xl mx-auto px-4 mt-6 border-t pt-4 flex justify-between items-center text-sm">
        <p>© {new Date().getFullYear()} {t('footer.copyRight')}</p>
        <a href="/privacy-policy" className="hover:underline">{t('footer.privacyPolicy')}</a>
      </div>
    </div>
  );
}
